/* eslint-disable angular/controller-as */
/* eslint-disable func-names */
/* eslint-disable angular/function-type */
/* eslint-disable angular/controller-name */
/* eslint-disable unicorn/filename-case */
import {getStarted} from '../segment'
;(function() {
  angular.module('app.ui.form.ctrls').controller('HomePageCtrl', [
    '$http',
    '$log',
    '$location',
    '$scope',
    '$filter',
    '$modal',
    'sharedProperties',
    'currentLawyer',
    '$window',
    'logger',
    '$cookies',
    '$route',
    '$rootScope',
    'userService',
    function(
      $http,
      $log,
      $location,
      $scope,
      $filter,
      $modal,
      sharedProperties,
      currentLawyer,
      $window,
      logger,
      $cookies,
      $route,
      $rootScope,
      userService
    ) {
      require('../../olark-chat-box.js')
      $scope.showProfileNavBar = false
      $scope.showAdminNavBar = false

      $scope.newUser = true
      $scope.pattern = /^[a-z]+[\d._a-z]+@[a-z]+\.[.a-z]{2,5}$/
      $scope.getParameterByName = function(name) {
        var regex
        var results
        name = name.replace(/\[/, '\\[').replace(/]/, '\\]')
        regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
        results = regex.exec($window.location.href)
        if (results === null) {
          return ''
        }

        return decodeURIComponent(results[1].replace(/\+/g, ' '))
      }

      $cookies.referralCode = $scope.getParameterByName('referralCode')
      if ($route.current.params.referralCode) {
        $rootScope.referralCode = $route.current.params.referralCode
      }

      $scope.showClass = ''
      $scope.showDropDown = function() {
        if ($scope.showClass === '') {
          $scope.showClass = 'show'
        } else {
          $scope.showClass = ''
        }
      }

      $scope.hideDropDown = function() {
        $scope.showClass = ''
      }

      $scope.notify = function(type, message) {
        switch (type) {
          case 'info':
            logger.log(
              "Heads up! This alert needs your attention, but it's not super important."
            )
            break
          case 'success':
            logger.logSuccess(message)
            break
          case 'warning':
            logger.logWarning(
              "Warning! Best check yo self, you're not looking too good."
            )
            break
          case 'error':
            logger.logError(
              'Oh snap! Change a few things up and try submitting again.'
            )
            break
          default:
            logger.logError('Unknown error')
        }
      }

      $scope.loadLawyers = function() {
        $http.post('/api/show-lawyers').then(
          function() {
            $location.url('/admin/admin-listings')
          },
          function(error) {
            $log.info('error', error)
          }
        )
      }

      $scope.loadFirms = function() {
        $http.post('/api/show-firms').then(
          function() {
            $location.url('/admin/admin-listings')
          },
          function(error) {
            $log.info('error', error)
          }
        )
      }

      $scope.loadInhouseJobs = function() {
        $http.post('/api/show-inhouse-firms').then(
          function() {
            $location.url('/admin/admin-listings?list=inhouse-jobs')
          },
          function(error) {
            $log.info('error', error)
          }
        )
      }

      $scope.navigateToinHouseJobs = function() {
        $http.post('/api/admin/navigate-email-listing').then(
          function() {
            $location.url('/admin/admin-listings?list=inhouse-jobs')
          },
          function(error) {
            $log.info('error', error)
          }
        )
      }

      $scope.homepageControls = function(type) {
        userService.getUser().then(user => {
          const roles =
            (user && user.roles && user.roles.map(role => role.id)) || []
          const isUser = roles.includes('user')
          if (!isUser) {
            $location.url('/signup')
          } else if (roles.includes('approved')) {
            $location.url('/matches')
          } else if (roles.includes('candidate')) {
            $location.url('/profile')
          } else if (roles.includes('agent') || roles.includes('admin')) {
            $location.url('/admin/admin-listings')
          } else if (!$scope.newUser) {
            $location.url('/user-profile')
          } else if ($scope.newUser && user && !user.isNewUser) {
            $location.url('/signup')
          } else if ($scope.newUser && user && user.isNewUser) {
            $location.url('profile')
          } else {
            $location.url('/signup')
          }

          homepageMainCTA(type)
        })
      }

      $scope.getStarted = function() {
        getStarted()
      }

      this.logOut = function() {
        $http
          .post('/api/logout', {
            withCredentials: 'true',
          })
          .then(
            function({data, status, headers, config}) {
              analytics.reset()
              $cookies.firstName = null
              $cookies.lastName = null
              $cookies.userType = null
              $cookies.lawyerStatus = null
              $scope.showProfileNavBar = false
              $scope.showAdminNavBar = false
              $scope.showClass = ''
              $scope.notify('success', 'You have successfully signed out.')
            },
            function(error) {}
          )
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/home/HomePageCtrl.js